import { Middleware, MiddlewareAPI } from 'redux';
import { xcaliberTokenAvailable } from '../../../actions/xcaliber.actions';
import {
  StorageAPI,
  isXCaliberTokenResponse,
  TOKEN_KEY,
  TOKEN_STATUS
} from '../xcaliber/xcaliber-token-manager';
import { isReduxAction } from '../../../typeguards';

const xcaliberTokenFactory = (storage: StorageAPI) => {

  const middleware: Middleware = (api: MiddlewareAPI) => next => action => {
    if (
      isReduxAction(action) &&
      action.type === xcaliberTokenAvailable.type &&
      isXCaliberTokenResponse(action.payload)
    ) {
      const status = action.payload.status?.toUpperCase();
      if (status === TOKEN_STATUS.SUCCESS) {
        storage.setItem(TOKEN_KEY, JSON.stringify(action.payload));
      }
    }
    return next(action);
  };

  const fetchXcaliberToken = () => {
    const xcaliberToken = storage.getItem(TOKEN_KEY) ?? '{}';
    try {
      return JSON.parse(`${xcaliberToken}`);
    } catch {
      return undefined;
    }
  };

  return { middleware, fetchXcaliberToken };
};

// immediately set this up with session storage.
// in the future other storage engines may be available
const {
  middleware: xcaliberTokenMiddleware,
  fetchXcaliberToken
} = xcaliberTokenFactory(sessionStorage);

export { xcaliberTokenMiddleware, fetchXcaliberToken };
